module.exports = __webpack_public_path__ + "static/media/star-and-crescent.8b8c739c.svg";